import type { CSSProperties, ReactNode } from 'react';
import { StatusMark } from './StatusMark';

/** The shared status tones (`now` = in progress, the coral tile), plus `live` for the live map (blue). */
export type Tone = 'neutral' | 'ok' | 'partial' | 'fail' | 'now' | 'live';

export interface BadgeProps {
  children?: ReactNode;
  /** Status hues are functional only. */
  tone?: Tone;
  /** A status mark: a leading square whose shape follows the tone, plus the word (Tangram). */
  dot?: boolean;
  size?: 'sm' | 'md';
  /** Mono type, for raw enum tokens and numbers. */
  mono?: boolean;
  /** The raw token stays inspectable on the element. */
  title?: string;
  'data-status'?: string;
  style?: CSSProperties;
}

/** A quiet chip for raw tokens and notes; with `dot`, a status mark (shape + word, never colour alone). */
export function Badge({ children, tone = 'neutral', dot = false, size = 'md', mono = false, title, style, ...rest }: BadgeProps) {
  const classes = ['fs-badge'];
  if (tone !== 'neutral') classes.push(`fs-badge--${tone}`);
  if (size === 'sm') classes.push('fs-badge--sm');
  if (mono) classes.push('fs-badge--mono');
  if (dot) classes.push('fs-badge--mark');
  return (
    <span className={classes.join(' ')} title={title} data-status={rest['data-status']} style={style}>
      {dot && <StatusMark tone={tone} />}
      {children}
    </span>
  );
}
